import { slugify } from '@wwe-portal/web/utils/string';
import Link from 'next/link';
import { FC, ReactNode } from 'react';

export const FactionLink: FC<{
  name?: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}> = ({ name, children, className, onClick }) => {
  if (!name) return <div className={className}>{children}</div>;
  return (
    <Link
      scroll
      className={className}
      href={`/faction/${slugify(name)}`}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
